export default function PaymentShippingInfo() {
  const infoBlocks = [
    {
      icon: 'ri-bank-card-line',
      title: 'Payment Methods',
      description: 'We support flexible payment options including bank transfer, international wire payments, and major cross-border payment channels commonly used by wholesale buyers.'
    },
    {
      icon: 'ri-ship-line',
      title: 'Shipping Options',
      description: 'We provide multiple international logistics solutions. Buyers may choose their own freight forwarder or request our team to arrange shipping based on destination and lead time.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Order Handling',
      description: 'Orders are processed with strict verification. Once payment is confirmed, goods are packed and prepared for dispatch according to standard wholesale procedures.'
    }
  ];

  return (
    <section className="w-full bg-gray-50 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Payment &amp; Shipping Info
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Flexible payment and shipping solutions for wholesale buyers worldwide
          </p>
        </div>

        {/* Info Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {infoBlocks.map((block, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-8 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              {/* Icon */}
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className={`${block.icon} text-5xl text-blue-600`}></i>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {block.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed">
                {block.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
